<svg version="1.1" [attr.viewBox]="viewBox" [ngStyle]="{ width: size + 'px', height: size + 'px' }">
  <path [attr.d]="data" />
</svg>
